<template>
    <div class="row">
        <div
            class="col-12 col-md-4 tw-mb-10 md:tw-mb-0 tw-flex tw-justify-center tw-items-center "
        >
            <div>
                <img
                    :src="user.user_detail.image_url"
                    @error="imageError"
                    class="tw-max-w-full tw-height-auto"
                    alt="user setting"
                    v-if="user.user_detail.image_url"
                />
                <i
                    class="fa fa-image tw-text-gray-200"
                    style="font-size: 9rem"
                    v-else
                ></i>
            </div>
        </div>

        <div class="col-12 col-md-8">
            <div class="row mb-4">
                <div class="col-sm-6">
                    <label for="" class="user--title">ชื่อ</label>
                    <div class="user--detail">
                        {{ user.name }}
                    </div>
                </div>
                <div class="col-sm-6">
                    <label for="" class="user--title">เบอร์โทรศัพท์</label>
                    <div class="user--detail">
                        {{ user.user_detail.phone || "-" }}
                    </div>
                </div>
            </div>

            <div class="row mb-4">
                <div class="col-sm-6">
                    <label for="" class="user--title">อีเมล </label>
                    <div class="user--detail">
                        {{ user.email || "-" }}
                    </div>
                </div>
                <div class="col-sm-6">
                    <label for="" class="user--title">รหัสผ่าน</label>
                    <div class="user--detail">
                        <a :href="`/backend/s/${shop}/user-setting/password`">
                            <button class="btn btn-dark">จัดการรหัสผ่าน</button>
                        </a>
                    </div>
                </div>
            </div>

            <div class="row mb-4">
                <div class="col-sm-6">
                    <label for="" class="user--title"
                        >รับแจ้งเตือนข่าวสาร
                    </label>
                    <div
                        class=" tw-rounded tw-text-center tw-w-full tw-flex tw-items-center"
                    >
                        <svg
                            v-if="!!user.is_notification"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="tw-w-6 tw-h-6"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="m4.5 12.75 6 6 9-13.5"
                            />
                        </svg>
                        <svg
                            v-if="!user.is_notification"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            class="tw-w-6 tw-h-6"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                            />
                        </svg>

                        <span class="tw-ml-2">
                            {{
                                user.is_notification
                                    ? "รับแจ้งเตือน"
                                    : "ไม่รับแจ้งเตือน"
                            }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        shop: {
            type: String,
            required: true
        },
        user: {
            required: true,
            type: Object
        }
    },
    data() {
        return {
            // default_img: "/images/no_pictures.png"
        };
    },
    methods: {
        imageError(event) {
            event.target.src = this.default_img;
        }
    }
};
</script>

<style lang="scss" scoped>
.user--title {
    @apply tw-mb-0 tw-text-sm tw-font-normal;
    color: var(--primary-color2);
}
.user--detail {
    @apply tw-text-lg;
}
</style>
